<bn-account-detail-base [product]="product"
                        [hostRef]="hostRef"
                        [productNumberFormat]="productNumberFormat"
                        [title1]="accountDetailTitle"
                        [title2]="creditTitle"
                        [title3]="statementsTitle"
                        [title4]="otherInfoTitle">

  <div details>
    <div class="account-detail-base__item">
      <div><strong i18n="@@product.details.monthInstallment">Month installment</strong></div>
      <div>
        {{ product?.additions?.minimumPmtDOP | bnCurrencyPipe:localCurrency }}
        <bn-semaphore-tooltip *ngIf="dopSemaphore.type"
                              [text]="dopSemaphore.text"
                              [type]="dopSemaphore.type"></bn-semaphore-tooltip>
      </div>
      <div>
        {{ product?.additions?.minimumPmtUSD | bnCurrencyPipe:foreignCurrency }}
        <bn-semaphore-tooltip *ngIf="usdSemaphore.type"
                              [text]="usdSemaphore.text"
                              [type]="usdSemaphore.type"></bn-semaphore-tooltip>
      </div>
    </div>
    <div class="account-detail-base__item">
      <div><strong i18n="@@product.details.totalPayment">Total payment</strong></div>
      <div>{{ product?.additions?.lastBalanceDOP | bnCurrencyPipe:localCurrency }}</div>
      <div>{{ product?.additions?.lastBalanceUSD | bnCurrencyPipe:foreignCurrency }}</div>
    </div>
  </div>

  <div detailsFooter>
    <div class="account-detail-base__item">
      <div><strong i18n="@@product.details.paymentDueDate">Payment date due</strong></div>
      <div *ngIf="product?.minimumPaymentDueDate != -1">{{ product?.minimumPaymentDueDate | bnEsDate  }}</div>
      <div *ngIf="product?.minimumPaymentDueDate == -1">--</div>
    </div>
  </div>

  <div row2
       class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.multicredit.availableCredit">Available credit</strong></div>
        <div>
          {{ product?.additions?.availableBalanceDOP | bnCurrencyPipe:localCurrency }}
        </div>
        <div>{{ product?.additions?.availableBalanceUSD | bnCurrencyPipe:foreignCurrency }}</div>
      </div>
      <div class="account-detail-base__item account-detail-base__item--blue">
        <div><strong i18n="@@product.details.creditLimit">Credit limit</strong></div>
        <div>
          {{ product?.additions?.creditLimitDOP | bnCurrencyPipe:localCurrency }}
        </div>
        <div>{{ product?.additions.creditLimitUSD | bnCurrencyPipe:foreignCurrency }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.creditDate">Credit to date</strong></div>
        <div>{{ product?.additions?.totalBalanceDOP | bnCurrencyPipe:localCurrency }}</div>
        <div>{{ product?.additions?.totalBalanceUSD | bnCurrencyPipe:foreignCurrency  }}</div>
      </div>
    </div>
  </div>

  <div row3
       class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.lastStatementDate">Last statement date</strong></div>
        <div *ngIf="product?.additions?.cutoffdate && product?.additions?.cutoffdate != -1">{{ product?.additions?.cutoffdate }}</div>
        <div *ngIf="product?.additions?.cutoffdate == -1 || !product?.additions?.cutoffdate">--</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.lastPayment">Last payment</strong></div>
        <div>{{ product?.additions?.lastPmtAmountDOP | bnCurrencyPipe:localCurrency }}</div>
        <div>{{ product?.additions?.lastPmtAmountUSD | bnCurrencyPipe:foreignCurrency }}</div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.lastPaymentDate">Last payment date</strong></div>
        <div *ngIf="product?.additions?.lastPmtDate != -1">{{ product?.additions?.lastPmtDate | bnEsDate }}</div>
        <div *ngIf="product?.additions?.lastPmtDate == -1">--</div>
      </div>
    </div>
  </div>

  <div row4
       class="row">
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.overdueInstallments">Overdue installments</strong></div>
        <div>{{ product?.additions?.expiredFees | bnEmpty }}</div>
      </div>
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.overdueAmount">Overdue amount</strong></div>
        <div>
          {{ product?.additions?.totalPaymentDOP | bnCurrencyPipe:localCurrency }}
        </div>
        <div>
          {{ product?.additions?.totalPaymentUSD | bnCurrencyPipe:foreignCurrency }}
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="account-detail-base__item">
        <div><strong i18n="@@product.details.interestRate">Interest rate</strong></div>
        <div>
          {{ product?.additions?.accountInterestRateDOP == -1 ? '--' : product?.additions?.accountInterestRateDOP + '%' }}
        </div>
        <div>
          {{ product?.additions?.accountInterestRateUSD == -1 ? '--' : product?.additions?.accountInterestRateUSD + '%' }}
        </div>
      </div>
    </div>
  </div>


</bn-account-detail-base>
